import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { defaultSettings, settingsSchema, type AppSettings } from '@albion/shared';

interface AppState {
  settings: AppSettings;
  favoriteItemIds: string[];
  toast: string | null;
  setSettings: (settings: AppSettings) => void;
  toggleFavorite: (itemId: string) => void;
  setToast: (toast: string | null) => void;
  resetSettings: () => void;
}

export const useAppStore = create<AppState>()(persist((set) => ({
  settings: defaultSettings,
  favoriteItemIds: [],
  toast: null,
  setSettings: (settings) => set({ settings: settingsSchema.catch(defaultSettings).parse(settings) }),
  toggleFavorite: (itemId) => set((state) => ({ favoriteItemIds: state.favoriteItemIds.includes(itemId) ? state.favoriteItemIds.filter((id) => id !== itemId) : [...state.favoriteItemIds, itemId] })),
  setToast: (toast) => set({ toast }),
  resetSettings: () => set({ settings: defaultSettings }),
}), { name: 'albion-economy-hub', partialize: (state) => ({ settings: state.settings, favoriteItemIds: state.favoriteItemIds }) }));
